<div class="mt-0 mt-md-2 mb-1 mb-md-0">
  <div class="alert-container alert-warning mb-0" role="alert" data-e2e="alertContainer">
    <p class="alert">
      <span class="alert-icon icon-Warning-important" aria-hidden="true"></span>
      <span class="text-mw" data-e2e="alert-title">{{viewModel.title}}</span>
    </p>
    <div class="alert-content">
      @if (viewModel.unpaid) { @if (viewModel.text) {
      <p class="alert-text" data-e2e="alert-text">{{viewModel.text}}</p>
      }
      <div class="item-button">
        @if (!displayButton) {
        <button class="btn btn-secondary" (click)="openLink()" data-e2e="alert-button">
          {{viewModel.button.label}}
        </button>
        }
      </div>
      } @else { @if (viewModel.text && isMobile) {
      <p class="alert-text" data-e2e="alert-text">{{viewModel.text}}</p>
      } @if (!isMobile) {
      <div class="item-button">
        <button class="btn btn-secondary" (click)="openLink()" data-e2e="alert-button">
          {{viewModel.button.label}}
        </button>
      </div>
      } }
    </div>
  </div>
</div>
